<template>
  <v-window
    v-model="tab"
    class="pa-3"
    style="background: #2d2d2d; border-radius: 5px; height: 220px"
    height="220px"
    show-arrows="hover">
    <v-alert
      class="mx-3"
      variant="tonal"
      type="info"
      style="margin-right: 0px !important; margin-left: 0px !important"
      v-if="assets.length === 0">
      No assets are available for preview in this scene.
    </v-alert>
    <v-window-item
      cover
      v-for="(selected, i) in assets"
      :key="i">
      <div style="width: 100%; display: flex; justify-content: center">
        <div
          style="
            border-radius: 5px;
            color: white;
            z-index: 10;
            position: absolute;
          "
          class="d-flex transbackground ma-3 pa-2">
          <div class="mx-3">
            {{ selected.key }} - {{ deluge.assets[selected.value].name }}
          </div>
        </div>
      </div>

      <div
        style="
          background: #2d2d2d;
          border-radius: 5px;
          padding: 5px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 200px;
        ">
        <div
          style="height: 100%; width: 100%"
          v-if="show_preview">
          <video
            v-if="
              selected.value.toLowerCase().includes('.mp4') ||
              selected.value.toLowerCase().includes('.webm')
            "
            draggable="false"
            muted
            autoplay
            loop
            controls
            :src="
              state.devRedirect +
              state.$ident +
              '/api/download_asset?uid=' +
              selected.uid +
              '&token=' +
              auth
            "
            style="
              object-fit: contain;
              height: 100%;
              width: 100%;
              border-radius: 4px;
            "></video>
          <video
            v-else-if="selected.preview_motion_medium"
            draggable="false"
            muted
            autoplay
            loop
            controls
            :src="
              state.devRedirect + state.$ident + selected.preview_motion_medium
            "
            style="
              object-fit: contain;
              height: 100%;
              width: 100%;
              border-radius: 4px;
            "></video>
          <v-img
            v-else-if="is_img(selected.value)"
            :lazy-src="
              state.devRedirect + state.$ident + selected.preview_static_small
            "
            loading="lazy"
            :src="
              state.devRedirect +
              state.$ident +
              '/api/download_asset?uid=' +
              selected.uid +
              '&token=' +
              auth
            "
            draggable="false"
            style="height: 100%; width: 100%; border-radius: 4px">
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="primary"
                  indeterminate></v-progress-circular>
              </div>
            </template>
          </v-img>
          <v-img
            loading="lazy"
            v-else
            :src="
              state.devRedirect + state.$ident + selected.preview_static_small
            "
            draggable="false"
            style="
              object-fit: contain;
              height: 100%;
              width: 100%;
              border-radius: 4px;
            " />
        </div>
        <div
          v-else
          style="height: 100%; width: 100%">
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
              color="primary"
              indeterminate></v-progress-circular>
          </div>
        </div>
      </div>
    </v-window-item>
  </v-window>
</template>
<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { state } from '../../stores/deluge.js';
import { deluge } from '@/stores/deluge.js';

const tab = ref(0);
const props = defineProps(['scene']);
const assets = ref([]);
const auth = ref(localStorage.getItem('authentication_token'));
onMounted(() => {
  AllAssets();
});
function AllAssets() {
  for (const key in deluge.items[props.scene.did].svars) {
    if (deluge.items[props.scene.did].svars[key].type === 'asset') {
      var new_obj = {};
      new_obj = deluge.items[props.scene.did].svars[key];
      new_obj['key'] = key;
      assets.value.push(new_obj);
    }
  }
}
</script>
